module.exports = __webpack_public_path__ + "img/musiwa.b228b21b.png";